module.exports = __webpack_public_path__ + "img/method_anatomy.00332211.png";